<template>
    <!-- 对话框 -->
    <el-dialog append-to-body title="软件平台通知提醒" :visible.sync="show" :center="true" :before-close="closeDialog" append-to-body
               :show-close="false" style="width:60%; margin: 0 auto;">


        <p>尊敬的用户您好，您有新的消息通知，请在首页“软件平台通知”查看通知内容</p>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">确认</el-button>
        </span>


    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean,

        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;


            }

        },
        data() {
            return {

                show: false


            };
        },
        created() {
            _this = this;

        },
        methods: {

            // 关闭方法
            closeDialog() {

                _this.show = false;


            }


        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
</style>
